module.exports = __webpack_public_path__ + "static/media/bancoBrasil.7b2da16a.svg";